/* eslint-disable func-names */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
const isArray = require('lodash/isArray');
const isString = require('lodash/isString');
const pull = require('lodash/pull');

let id = 0;

class Node {
  constructor(data) {
    this.id = ++id;
    if (isArray(data)) {
      this.open = data[0];
      this.close = data[1];
    } else if (isString(data)) {
      this.text = data;
    }
    this.children = [];
  }

  append(e) {
    if (!(e instanceof Node)) {
      e = new Node(e);
    }
    if (e._parent) {
      pull(e._parent.children, e);
    }
    e._parent = this;
    this.children = this.children.concat(e);
  }

  render() {
    let text = '';
    if (this.open) {
      text += this.open;
    }
    if (this.text) {
      text += this.text;
    }
    for (let i = 0; i < this.children.length; i++) {
      text += this.children[i].render();
    }
    if (this.close) {
      text += this.close;
    }
    return text;
  }

  parent() {
    return this._parent;
  }
}

module.exports = {
  embed: {
    image(src) {
      this.append(`\n![](${src})\n`);
    },
    // Not a default Quill feature, converts custom divider embed blot added when
    // creating quill editor instance.
    // See https://quilljs.com/guides/cloning-medium-with-parchment/#dividers
    thematic_break() {
      this.open = `\n---\n${this.open}`;
    },
    emoji(src) {
      const { native } = src;
      this.append(`${native}`);
    },
    mention(src) {
      const { denotationChar, name, id: userId } = src;
      const removedUserPrefix = userId.replace('user-', '');
      this.append(`${denotationChar}[${name}](${removedUserPrefix})`);
    },
  },

  inline: {
    italic() {
      return ['_', '_'];
    },
    bold() {
      return ['**', '**'];
    },
    link(url) {
      return ['[', `](${url})`];
    },
    code() {
      return ['`', '`'];
    },
  },

  block: {
    'code-block': function () {
      this.open = `\`\`\`\n${this.open}`;
      this.close += '```\n';
    },
    header({ header }) {
      this.open = `${'#'.repeat(header)} ${this.open}`;
    },
    blockquote() {
      this.open = `> ${this.open}`;
    },
    list: {
      group() {
        return new Node(['', '\n']);
      },
      line(attrs, group) {
        if (attrs.list === 'bullet') {
          this.open = `- ${this.open}`;
        } else if (attrs.list === 'checked') {
          this.open = `- [x] ${this.open}`;
        } else if (attrs.list === 'unchecked') {
          this.open = `- [ ] ${this.open}`;
        } else if (attrs.list === 'ordered') {
          group.count = group.count || 0;
          const count = ++group.count;
          this.open = `${count}. ${this.open}`;
        }
      },
    },
  },
};
